import { Injectable } from '@angular/core';
import { Logger } from '../services/logger.service';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly logger = new Logger(AuthInterceptor.name);

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.authService.getToken();

    const requestToHandle = token
      ? request.clone({
          headers: request.headers.set('Authorization', `Bearer ${token}`),
        })
      : request;

    return next.handle(requestToHandle).pipe(
      catchError((error: HttpErrorResponse) => {
        this.logger.debug('HTTP error intercepted', error);

        if (error.status === 401) {
          this.logger.info('401 Unauthorized - logging out user');
          this.authService.logout();
          // Use navigateByUrl to ensure navigation happens even if current route is protected
          this.router.navigateByUrl('/auth/sign-in').catch(navError => {
            this.logger.error('Navigation error after logout', navError);
          });
          // Still throw the error so the calling code knows the request failed
          // but the user is already being redirected
          return throwError(() => error);
        }

        return throwError(() => error);
      })
    );
  }
}
